var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 15,
    viewBox: "0 0 7 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53464 0.872155H6.75264L2.13264 14.0602H0.914641L5.53464 0.872155Z",
    fill: "#5D616F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathSlash);
export default __webpack_public_path__ + "static/media/path_slash.fdbb30a57f4b0379ecf6a659cb53f22f.svg";
export { ForwardRef as ReactComponent };